import '../FaqCard.scss';

import { Cpu } from '@phosphor-icons/react';
import { useTranslation } from 'react-i18next';

const className = 'c-FaqCard';

const FaqCardEsimExplained = () => {
  const { t } = useTranslation();

  return (
    <div>
      <div className={`${className}__center`}>
        <Cpu size={48} aria-hidden="true" />;
      </div>

      <h2 className={`${className}__faq_card_title`}>
        {t('landing.esim_explained_card1.title', 'What is eSIM?')}
      </h2>
      <p>
        {t(
          'landing.esim_modal1.1',
          'An eSIM is a digital SIM that simplifies staying connected while traveling abroad, eliminating the need to swap physical SIM cards.',
        )}
      </p>

      <p>
        {t(
          'landing.esim_modal1.2',
          ' More importantly, it means you can avoid expensive roaming charges.',
        )}
      </p>
      <p>
        {t(
          'landing.esim_modal1.3',
          'Simply download a plan and connect in a few taps!',
        )}
      </p>
    </div>
  );
};

export default FaqCardEsimExplained;
